module.exports = __webpack_public_path__ + "h5/img/help2.8d18720c.png";